
namespace TabAurous.Master {

    @Serenity.Decorators.registerClass()
    export class SalesPersonDialog extends Serenity.EntityDialog<SalesPersonRow, any> {
        protected getFormKey() { return SalesPersonForm.formKey; }
        protected getIdProperty() { return SalesPersonRow.idProperty; }
        protected getLocalTextPrefix() { return SalesPersonRow.localTextPrefix; }
        protected getNameProperty() { return SalesPersonRow.nameProperty; }
        protected getService() { return SalesPersonService.baseUrl; }
        protected getDeletePermission() { return SalesPersonRow.deletePermission; }
        protected getInsertPermission() { return SalesPersonRow.insertPermission; }
        protected getUpdatePermission() { return SalesPersonRow.updatePermission; }

        protected form = new SalesPersonForm(this.idPrefix);
        constructor() {
            super();

        }
        protected validateBeforeSave() {
            var targets = this.form.Details.getItems();
            
            for (var i = 0; i < targets.length; i++) {
                var sameTarget = targets.filter(x => x.BaseItemTypeId === targets[i].BaseItemTypeId && x.FinancialYearId === targets[i].FinancialYearId);
                if (sameTarget.length > 1) {
                    Q.notifyError('Multiple Targets for Same Attributes not allowed! At row: ' + i);
                    return false;
                }
                if (targets[i].Amount == 0 || targets[i].Quantity == 0) {
                    Q.notifyError('Target Amount/Quantity is Zero! At row: '+(i+1));
                }
            }
        }
    }
}